import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";

var _this = this;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useEffect, useRef, useState, Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import cx from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import $ from 'jquery';
import PopupDialog from 'ui/components/popup-dialog';
import Progress from '../ui/react-ui/progress.jsx';
import ModalDialog from '../ui/modal-dialog';
import Form from '../ui/form';
import { decodeBase64, encodeBase64 } from '../../utils';
import * as fromConditionParser from '../../utils/conditionParser';
import { drawingToolApp, getMeta } from '../ui/DrawingToolApp';
import DrawingToolReadBox from '../ui/DrawingToolReadBox.jsx'; // import AnalyticSetup from './analytic-setup'

import ConditionSetupPopup from './ConditionSetupPopup'; // api

import { getCameraVaProfileList, createCameraVaProfileAPI, setCameraVaProfileAPI, getCameraVaScheduleList, setCameraVaScheduleAPI, deleteCameraVaProfileAPI } from '../../api/deviceAPI'; // redux

import { setNvrIp } from '../../redux/setting-device';
var t = i18n.getFixedT(null, 'setting-device');
var gt = i18n.getFixedT(null, 'app');
var et = i18n.getFixedT(null, 'errors');
var graphicPrefix = {
  area: "area",
  area_: "area_",
  direction: "direction",
  direction_: "direction_",
  cross_line_: "cross_line_",
  cross_line: "cross_line",
  line: "line",
  line_: "line_",
  cross_line_pair: "cross_line_pair",
  cross_line_pair_: "cross_line_pair_",
  bir_analysis_roi: "bir_analysis_roi",
  bir_crossing_line: "bir_crossing_line",
  bir_trace_line: "bir_trace_line",
  bir_dwelling_roi: "bir_dwelling_roi",
  bir_occupancy_roi: "bir_occupancy_roi"
};
var GRAPHIC_OPACITY = 0.6;
var AnalyticCameraEdit = /*#__PURE__*/React.memo(function (props) {
  // redux
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot;

  _objectDestructuringEmpty(_useSelector.device);

  var dispatch = useDispatch();
  var id = props.id,
      onClose = props.onClose,
      cameraData = props.cameraData;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      openAnalyticSetup = _useState2[0],
      setOpenAnalyticSetup = _useState2[1];

  var _useState3 = useState({}),
      _useState4 = _slicedToArray(_useState3, 2),
      profile = _useState4[0],
      setProfile = _useState4[1]; // const [ snapshotUrl, setSnapshotUrl ] = useState('')


  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      conditionItems_items = _useState6[0],
      setConditionItems_items = _useState6[1];

  var _useState7 = useState(),
      _useState8 = _slicedToArray(_useState7, 2),
      conditionItems_displayItems = _useState8[0],
      setConditionItems_displayItems = _useState8[1];

  var _useState9 = useState(),
      _useState10 = _slicedToArray(_useState9, 2),
      conditionItems_displayItem = _useState10[0],
      setConditionItems_displayItem = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      enableVaSchedule = _useState12[0],
      setEnableVaSchedule = _useState12[1];

  var _useState13 = useState('multi'),
      _useState14 = _slicedToArray(_useState13, 2),
      viewStatus = _useState14[0],
      setViewStatus = _useState14[1];

  var _useState15 = useState(),
      _useState16 = _slicedToArray(_useState15, 2),
      error = _useState16[0],
      setError = _useState16[1];

  var _isMounted = useRef(false);

  var _initTemplate = useRef();

  var _isNewProfile = useRef(false);

  var _selectedCondition = useRef(0);

  var _isReset = useRef(false);

  var paramType = ['string', 'boolean', 'float', 'integer', 'multi_selection', 'multi_string', 'radio'];
  var geometryType = ['rectangle', 'line', 'direction', 'polygon', 'polyline'];

  var handleCloseSetup = function handleCloseSetup() {
    setOpenSetup(false);
  };

  var handleClose = function handleClose() {
    onClose();
  };

  var handleVaSchedule = function handleVaSchedule() {
    setCameraVaScheduleAPI(contextRoot, false, cameraData.nvr.ip, cameraData.channel, profile.id, !enableVaSchedule).then(function (result) {
      console.log(result);
      setEnableVaSchedule(!enableVaSchedule);
    });
  };

  var handleCreateNewVaProfile = function handleCreateNewVaProfile(initTemple, noProgress) {
    return new Promise(function (resolve, reject) {
      var newVaProfile = {
        conditionBase64: initTemple.conditionBase64,
        description: '',
        name: 'new_profile',
        note: {
          analyticalStream: 1,
          channel: cameraData.channel,
          templateId: initTemple.id
        },
        tagColor: ''
      };
      createCameraVaProfileAPI(contextRoot, noProgress, cameraData.nvr.ip, newVaProfile).then(function (createResult) {
        resolve(createResult.content[0]);
      }).catch(function (error) {
        reject(error);
      });
    });
  };

  var handleReset = function handleReset() {
    PopupDialog.confirm({
      title: t("dlg-reset-profile"),
      display: t("txt-reset-init-profile"),
      cancelText: gt('global.lbl-answer-cancel'),
      confirmText: gt('global.lbl-answer-ok'),
      act: function act(confirmed) {
        if (confirmed) {
          Progress.startSpin();
          deleteCameraVaProfileAPI(contextRoot, true, cameraData.nvr.ip, profile.id).then(function (result) {
            handleCreateNewVaProfile(_initTemplate.current, true).then(function (resultProfile) {
              setProfile(resultProfile);
              Progress.done();
            });
          });
        }
      }
    });
  };

  var handleViewStatus = function handleViewStatus(val) {
    setViewStatus(val);
  };

  var getCondition = function getCondition(d) {
    var p = d ? d : profile;

    var getValue = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(p, type) {
        var value, options, multiSelectValue, strings, radioValue, defaultId, url, realXmlObj, interOptions, _url, dynamicRadioValue;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                value = undefined;
                _context.t0 = type;
                _context.next = _context.t0 === 'boolean' ? 4 : _context.t0 === 'integer' ? 4 : _context.t0 === 'float' ? 4 : _context.t0 === 'multi_selection' ? 6 : _context.t0 === 'multi_string' ? 11 : _context.t0 === 'radio' ? 14 : _context.t0 === 'dynamic_radio' ? 20 : _context.t0 === 'string' ? 35 : 35;
                break;

              case 4:
                value = p._;
                return _context.abrupt("break", 37);

              case 6:
                multiSelectValue = {};
                options = _.get(p, 'option_list[0].option', []);

                if (options) {
                  options.map(function (op, index) {
                    var oid = op.$.id;
                    var isCheck = op._ == "1" || op._ === undefined && op.$.default == "1";
                    multiSelectValue[oid] = isCheck;
                  });
                }

                value = {
                  $custom: 'multi_selection',
                  options: multiSelectValue
                };
                return _context.abrupt("break", 37);

              case 11:
                strings = _.get(p, 'string_list[0].string', []);
                value = {
                  $custom: 'multi_string',
                  strings: strings
                };
                return _context.abrupt("break", 37);

              case 14:
                radioValue = undefined;
                options = _.get(p, 'option_list[0].option', []);

                if (options) {
                  options.map(function (op, index) {
                    if (op.$.default == "1") {
                      defaultId = op.$.id;
                    }

                    if (op._ == "1") {
                      radioValue = op.$.id;
                    }
                  });
                }

                if (!radioValue) {
                  radioValue = defaultId;
                }

                value = {
                  $custom: 'radio',
                  value: radioValue
                };
                return _context.abrupt("break", 37);

              case 20:
                console.log('ad isNewProfile', _isNewProfile.current);

                if (!(_isNewProfile.current === true)) {
                  _context.next = 32;
                  break;
                }

                url = _.get(p, '$.src', null);
                realXmlObj = p;
                interOptions = _.get(p, 'intersectional_option_list[0].option', []);
                _url = url.replace('{', '');
                _url = _url.replace('}', '');
                _context.next = 29;
                return getDynamicRadioOptions(_url, realXmlObj, interOptions);

              case 29:
                value = _context.sent;
                _context.next = 34;
                break;

              case 32:
                dynamicRadioValue = _.get(p, 'option_list[0].option', []);
                value = {
                  $custom: 'dynamic_radio',
                  value: dynamicRadioValue
                };

              case 34:
                return _context.abrupt("break", 37);

              case 35:
                value = p._;
                return _context.abrupt("break", 37);

              case 37:
                return _context.abrupt("return", value);

              case 38:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getValue(_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }();

    return getTemplate(p.note.templateId).then(function (template) {
      var xml = decodeBase64(p.conditionBase64);

      if (window.isDev) {
        console.log('hl xml: ', xml);
      } // return the structure of this profile without template id


      if (!template) {
        // console.log('hl check template: ', template)
        return fromConditionParser.create(xml);
      } //console.log('ad xml', xml)
      // clone properties' values from profile to template


      return fromConditionParser.create(xml).then( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(profile) {
          var items;
          return _regeneratorRuntime.wrap(function _callee10$(_context10) {
            while (1) {
              switch (_context10.prev = _context10.next) {
                case 0:
                  _context10.next = 2;
                  return profile.getConditionItems();

                case 2:
                  items = _context10.sent;

                  if (!items) {
                    _context10.next = 9;
                    break;
                  }

                  _context10.next = 6;
                  return Promise.all(items.map( /*#__PURE__*/function () {
                    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(item) {
                      var cid, sid, cond;
                      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                        while (1) {
                          switch (_context9.prev = _context9.next) {
                            case 0:
                              if (!item) {
                                _context9.next = 9;
                                break;
                              }

                              cid = item.cid, sid = item.sid;
                              cond = profile.getCondition(cid, sid); //console.log('hl check condition: ', cond)

                              if (!cond) {
                                _context9.next = 9;
                                break;
                              }

                              if (!cond.parameterList) {
                                _context9.next = 7;
                                break;
                              }

                              _context9.next = 7;
                              return Promise.all(Object.keys(cond.parameterList).map( /*#__PURE__*/function () {
                                var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(pid) {
                                  var paramObj, value, options;
                                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                                    while (1) {
                                      switch (_context2.prev = _context2.next) {
                                        case 0:
                                          paramObj = profile.getParameter({
                                            cid: cid,
                                            sid: sid,
                                            pid: pid
                                          }); // let paramObj = profile.getParameter(cid, pid, sid)
                                          //console.log('hl paramObj: ', paramObj)
                                          // console.log('ad cond', cond)

                                          // let paramObj = profile.getParameter(cid, pid, sid)
                                          //console.log('hl paramObj: ', paramObj)
                                          // console.log('ad cond', cond)
                                          value = undefined;

                                          if (!paramObj) {
                                            _context2.next = 6;
                                            break;
                                          }

                                          _context2.next = 5;
                                          return getValue(paramObj, paramObj.$type);

                                        case 5:
                                          value = _context2.sent;

                                        case 6:
                                          if (value) {
                                            template.setParameter({
                                              cid: cid,
                                              sid: sid,
                                              pid: pid
                                            }, value); // template.setParameter(cid, pid, value, sid, undefined)
                                          }

                                        case 7:
                                        case "end":
                                          return _context2.stop();
                                      }
                                    }
                                  }, _callee2);
                                }));

                                return function (_x5) {
                                  return _ref4.apply(this, arguments);
                                };
                              }()));

                            case 7:
                              // clone geometry list
                              if (cond.geometryList) {
                                Object.keys(cond.geometryList).map(function (gid) {
                                  var geoObj = profile.getGeometry({
                                    cid: cid,
                                    sid: sid,
                                    gid: gid
                                  });

                                  if (geoObj) {
                                    template.setGeometry({
                                      cid: cid,
                                      sid: sid,
                                      gid: gid
                                    }, geoObj);
                                  }
                                });
                              } // clone geo condition list


                              // clone geo condition list
                              if (cond.geoConditionList) {
                                Object.keys(cond.geoConditionList).map( /*#__PURE__*/function () {
                                  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(gcId) {
                                    var geoCond;
                                    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                                      while (1) {
                                        switch (_context8.prev = _context8.next) {
                                          case 0:
                                            geoCond = cond.geoConditionList[gcId];

                                            if (geoCond.geometryList) {
                                              Object.keys(geoCond.geometryList).map(function (gid) {
                                                var g = geoCond.geometryList[gid];
                                                var layer_1 = {
                                                  layer: 1,
                                                  gid: g.$.id,
                                                  type: g.$type,
                                                  value: g
                                                };
                                                var geoObj = profile.getGeometry({
                                                  cid: cid,
                                                  sid: sid,
                                                  gid: gid,
                                                  gcid: gcId
                                                });

                                                if (geoObj) {
                                                  template.setGeometry({
                                                    cid: cid,
                                                    sid: sid,
                                                    gid: gid,
                                                    gcid: gcId
                                                  }, geoObj);
                                                }

                                                Object.keys(g).map( /*#__PURE__*/function () {
                                                  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(prop) {
                                                    var currentType, geomType;
                                                    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                                                      while (1) {
                                                        switch (_context6.prev = _context6.next) {
                                                          case 0:
                                                            currentType = paramType.find(function (type) {
                                                              return type == prop;
                                                            });

                                                            if (!currentType) {
                                                              _context6.next = 4;
                                                              break;
                                                            }

                                                            _context6.next = 4;
                                                            return Promise.all(g[currentType].map( /*#__PURE__*/function () {
                                                              var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(p) {
                                                                var type, pid, value, geoCondObj;
                                                                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                                                                  while (1) {
                                                                    switch (_context3.prev = _context3.next) {
                                                                      case 0:
                                                                        type = currentType, pid = p.$.id; // let value = p._

                                                                        _context3.next = 3;
                                                                        return getValue(p, currentType);

                                                                      case 3:
                                                                        value = _context3.sent;

                                                                        if (value) {
                                                                          geoCondObj = fromConditionParser.createGeoCondObj({
                                                                            gcid: geoCond.$.id,
                                                                            paramType: type,
                                                                            xmlObjList: [layer_1]
                                                                          });
                                                                          template.setParameter({
                                                                            cid: cid,
                                                                            sid: sid,
                                                                            pid: pid,
                                                                            geoCondObj: geoCondObj
                                                                          }, value); // template.setParameter(
                                                                          //     cid, pid, value, sid,
                                                                          //     createGeoCondObj(geoCond.$.id, type, [layer_1])
                                                                          // )
                                                                          // let paramXmlObj = { 
                                                                          //     type, 
                                                                          //     xmlObj: [layer_1] 
                                                                          // }
                                                                          // template.setParameter(cid, pid, value, sid, { 
                                                                          //     geoCondId: geoCond.$.id, 
                                                                          //     paramXmlObj
                                                                          // })
                                                                        }

                                                                      case 5:
                                                                      case "end":
                                                                        return _context3.stop();
                                                                    }
                                                                  }
                                                                }, _callee3);
                                                              }));

                                                              return function (_x8) {
                                                                return _ref7.apply(this, arguments);
                                                              };
                                                            }()));

                                                          case 4:
                                                            geomType = geometryType.find(function (type) {
                                                              return type == prop;
                                                            });

                                                            if (geomType) {
                                                              g[geomType].map(function (g2) {
                                                                var layer_2 = {
                                                                  layer: 2,
                                                                  gid: g2.$.id,
                                                                  type: geomType,
                                                                  value: g2
                                                                };
                                                                Object.keys(g2).map( /*#__PURE__*/function () {
                                                                  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(prop) {
                                                                    var currentType2;
                                                                    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                                                                      while (1) {
                                                                        switch (_context5.prev = _context5.next) {
                                                                          case 0:
                                                                            currentType2 = paramType.find(function (type) {
                                                                              return type == prop;
                                                                            });

                                                                            if (!currentType2) {
                                                                              _context5.next = 4;
                                                                              break;
                                                                            }

                                                                            _context5.next = 4;
                                                                            return Promise.all(g2[currentType2].map( /*#__PURE__*/function () {
                                                                              var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(p2) {
                                                                                var type2, pid2, value2, geoCondObj;
                                                                                return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                                                                                  while (1) {
                                                                                    switch (_context4.prev = _context4.next) {
                                                                                      case 0:
                                                                                        type2 = currentType2, pid2 = p2.$.id; // let value2 = p._

                                                                                        _context4.next = 3;
                                                                                        return getValue(p2, currentType2);

                                                                                      case 3:
                                                                                        value2 = _context4.sent;

                                                                                        if (value2) {
                                                                                          geoCondObj = fromConditionParser.createGeoCondObj({
                                                                                            gcid: geoCond.$.id,
                                                                                            paramType: type2,
                                                                                            xmlObjList: [layer_1, layer_2]
                                                                                          });
                                                                                          template.setParameter({
                                                                                            cid: cid,
                                                                                            sid: sid,
                                                                                            pid: pid2,
                                                                                            geoCondObj: geoCondObj
                                                                                          }, value2); // let paramXmlObj2 = {
                                                                                          //     type: type2,
                                                                                          //     xmlObj: [layer_1, layer_2]
                                                                                          // }
                                                                                          // template.setParameter(cid, pid2, value2, sid, {
                                                                                          //     geoCondId: geoCond.$.id,
                                                                                          //     paramXmlObj: paramXmlObj2
                                                                                          // })
                                                                                        }

                                                                                      case 5:
                                                                                      case "end":
                                                                                        return _context4.stop();
                                                                                    }
                                                                                  }
                                                                                }, _callee4);
                                                                              }));

                                                                              return function (_x10) {
                                                                                return _ref9.apply(this, arguments);
                                                                              };
                                                                            }()));

                                                                          case 4:
                                                                          case "end":
                                                                            return _context5.stop();
                                                                        }
                                                                      }
                                                                    }, _callee5);
                                                                  }));

                                                                  return function (_x9) {
                                                                    return _ref8.apply(this, arguments);
                                                                  };
                                                                }());
                                                              });
                                                            }

                                                          case 6:
                                                          case "end":
                                                            return _context6.stop();
                                                        }
                                                      }
                                                    }, _callee6);
                                                  }));

                                                  return function (_x7) {
                                                    return _ref6.apply(this, arguments);
                                                  };
                                                }());
                                              });
                                            }

                                            if (!geoCond.parameterList) {
                                              _context8.next = 5;
                                              break;
                                            }

                                            _context8.next = 5;
                                            return Promise.all(Object.keys(geoCond.parameterList).map( /*#__PURE__*/function () {
                                              var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(pid) {
                                                var p, value, geoCondObj;
                                                return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                                                  while (1) {
                                                    switch (_context7.prev = _context7.next) {
                                                      case 0:
                                                        p = geoCond.parameterList[pid]; // let value = p._

                                                        // let value = p._
                                                        value = undefined;

                                                        if (!p) {
                                                          _context7.next = 6;
                                                          break;
                                                        }

                                                        _context7.next = 5;
                                                        return getValue(p, p.$type);

                                                      case 5:
                                                        value = _context7.sent;

                                                      case 6:
                                                        if (value) {
                                                          geoCondObj = fromConditionParser.createGeoCondObj({
                                                            gcid: geoCond.$.id,
                                                            paramType: undefined,
                                                            xmlObjList: []
                                                          });
                                                          template.setParameter({
                                                            cid: cid,
                                                            sid: sid,
                                                            pid: pid,
                                                            geoCondObj: geoCondObj
                                                          }, value); // template.setParameter(cid, pid, value, sid, {
                                                          //     geoCondId: geoCond.$.id,
                                                          //     paramXmlObj: {
                                                          //         type: undefined,
                                                          //         xmlObj: []
                                                          //     }
                                                          // })
                                                        }

                                                      case 7:
                                                      case "end":
                                                        return _context7.stop();
                                                    }
                                                  }
                                                }, _callee7);
                                              }));

                                              return function (_x11) {
                                                return _ref10.apply(this, arguments);
                                              };
                                            }()));

                                          case 5:
                                          case "end":
                                            return _context8.stop();
                                        }
                                      }
                                    }, _callee8);
                                  }));

                                  return function (_x6) {
                                    return _ref5.apply(this, arguments);
                                  };
                                }());
                              }

                            case 9:
                            case "end":
                              return _context9.stop();
                          }
                        }
                      }, _callee9);
                    }));

                    return function (_x4) {
                      return _ref3.apply(this, arguments);
                    };
                  }()));

                case 6:
                  return _context10.abrupt("return", template);

                case 9:
                  return _context10.abrupt("return", template);

                case 10:
                case "end":
                  return _context10.stop();
              }
            }
          }, _callee10);
        }));

        return function (_x3) {
          return _ref2.apply(this, arguments);
        };
      }());
    });
  };

  var getTemplate = function getTemplate(id) {
    // let template = profile.find(item => item.id == id)
    //console.log('hl existed template: ', template)
    if (profile) {
      var templateXml = decodeBase64(profile.conditionBase64);
      return fromConditionParser.create(templateXml);
    } else {
      return Promise.resolve(undefined);
    }
  };

  var getTemplateName = function getTemplateName(profile) {
    var templateName = '';

    var isKeyExist = function isKeyExist(key) {
      var exist = true;

      if (_cond(key) == key) {
        exist = false;
      }

      return exist;
    };

    try {
      var templateId = profile.note.templateId;
      var key = "defaultCondition.".concat(templateId);

      if (!isKeyExist(key)) {
        // 語言包若無 key 值, 則取 template name 
        var p = _this.getSelecetdProfile(templateId);

        if (p) {
          templateName = p.name;
        } else {
          templateName = _cond("defaultCondition.noTemplateName");
        }
      } else {
        templateName = _cond(key);
      }
    } catch (error) {}

    return templateName;
  };

  var getSelecetdProfile = function getSelecetdProfile(id) {
    var _id = id;
    var target;

    _this.state.pList.map(function (p) {
      if (p.id == _id) {
        target = p;
      }
    });

    return target;
  };

  var getDynamicRadioOptions = /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(url, realXmlObj, interOptions) {
      var items, availOptions, value;
      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              items = [];
              availOptions = [];
              value = {};
              _context11.next = 5;
              return portalClient.getDynamicRadioOptions(url, realXmlObj).then(function (r) {
                try {
                  var _avail = r.availability;

                  if (_avail && _avail.length > 0) {
                    for (var i = 0; i < _avail.length; i++) {
                      var el = _avail[i];
                      availOptions.push({
                        id: el,
                        name: "str_".concat(el),
                        order: i.toString(),
                        default: "0"
                      });
                    }

                    var minValue = Infinity;
                    var minId = "";
                    interOptions.map(function (op, index) {
                      var find = availOptions.find(function (el) {
                        return el.id == op.$.id;
                      });

                      if (find) {
                        items.push({
                          id: op.$.id,
                          name: op.$.name,
                          order: op.$.order,
                          default: "0"
                        });

                        if (parseInt(op.$.default_priority) < minValue) {
                          minValue = parseInt(op.$.default_priority);
                          minId = op.$.id;
                        }
                      }
                    });
                    items.find(function (it) {
                      return it.id === minId;
                    }).default = "1";
                    var _items = [];
                    _items = items.map(function (it) {
                      return {
                        $: it
                      };
                    });
                    value = {
                      $custom: 'dynamic_radio',
                      value: _items
                    };
                    console.log('ad dynamic_radio value ', value);
                  }
                } catch (error) {
                  console.error('Parsing dynamic radio options fail', error);
                }
              }).catch(function (e) {
                console.error('getDynamicRadioOptions fail', e);
              });

            case 5:
              return _context11.abrupt("return", value);

            case 6:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }));

    return function getDynamicRadioOptions(_x12, _x13, _x14) {
      return _ref11.apply(this, arguments);
    };
  }();

  var renderConditionItems = function renderConditionItems() {
    return /*#__PURE__*/React.createElement(ConditionItems, {
      viewStatus: viewStatus,
      items: conditionItems_items,
      displayItems: conditionItems_displayItems,
      displayItem: conditionItems_displayItem // onChangeDisplayItem={this.handleChangeDisplayItem}
      ,
      onEdit: function onEdit(cid, sid) {
        setOpenAnalyticSetup(true);
        _selectedCondition.current.cid = cid;
        _selectedCondition.current.sid = sid;
      } // onToggle={(index, enable) => {
      //     items[index].onChangeEnable(enable)
      //     this.setState({});
      // }}

    });
  };

  var geometryListToObjList = function geometryListToObjList(geometryList) {
    var obj = [];

    if (!geometryList) {
      return [];
    }

    return Object.keys(geometryList).map(function (key) {
      return geometryList[key];
    });
  };

  var getGraphName = function getGraphName(key) {
    try {
      //console.log('hl graphic key: ', key.replace(/\d*/g, ''))
      var k = key.replace(/\d*/g, '');

      if (graphicPrefix.hasOwnProperty(k)) {
        var prefix = graphicPrefix[k];

        if (key.indexOf(prefix) >= 0) {
          var startIdx = key.indexOf(prefix);
          return t("graph.".concat(prefix)) + key.substring(startIdx + prefix.length);
        }
      } else {
        return key;
      }
    } catch (error) {
      console.error('getGraphName fail', error);
      return key;
    }
  };

  var geoConditionListToObjList = function geoConditionListToObjList(geoCondtionList) {
    var objects = [];
    Object.keys(geoCondtionList).map(function (gcid) {
      var geoCond = geoCondtionList[gcid];

      if (!geoCond) {
        return;
      }

      return Object.keys(geoCond.geometryList).map(function (gid) {
        var gcid = _.get(geoCond, '$.id', '');

        var g = _objectSpread(_objectSpread({}, geoCond.geometryList[gid]), {}, {
          tagName: getGraphName(gcid)
        });

        if (!g) {
          return;
        }

        objects.push(g);
      });
    });
    return objects;
  };

  var conditionToGeoObjList = function conditionToGeoObjList(condition) {
    if (!condition) {
      console.warn('conditionToGeoObjList receive invalid condition', condition);
      return [];
    }

    var geometryList = condition.geometryList;
    var objects = geometryListToObjList(geometryList);
    var geoCondtionList = condition.geoConditionList;

    if (geoCondtionList) {
      objects = objects.concat(geoConditionListToObjList(geoCondtionList));
    }

    return objects.map(function (g) {
      var objCount = _selectedCondition.current.getObjectCount({
        geometry: g
      });

      return getDrawingObjs(objCount, g);
    }).flat();
  };

  var renderGeoObjs = function renderGeoObjs() {
    var newParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _p = {};
    var _pKeys = ['displayItem', 'displayItems', 'viewStatus']; // let state = {
    //     displayItem: conditionItems_displayItem,
    //     displayItems: conditionItems_displayItems,
    //     viewStatus
    // }

    var state = {};

    _pKeys.map(function (k) {
      _p[k] = newParams[k] !== undefined ? newParams[k] : state[k];
    });

    var objects = [];
    var displayItem = _p.displayItem,
        displayItems = _p.displayItems,
        viewStatus = _p.viewStatus;

    if (viewStatus == "single" && displayItem) {
      var cond = _selectedCondition.current.getCondition(displayItem.cid, displayItem.sid);

      objects = conditionToGeoObjList(cond);
    } else if (viewStatus == "multi" && displayItems) {
      objects = displayItems.map(function (item) {
        var cond = _selectedCondition.current.getCondition(item.cid, item.sid);

        return conditionToGeoObjList(cond);
      }).flat();
    } // console.log("sj read objects =", objects)


    objects = objects.map(function (obj, index) {
      return _objectSpread(_objectSpread({}, obj), {}, {
        id: obj.id + "_".concat(index)
      });
    });

    var resolution = /*#__PURE__*/function () {
      var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var img, _width, _height;

        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return getMeta("".concat(contextRoot, "/camera/snapshot?nvrIp=").concat(cameraData.nvr.ip, "&channel=").concat(cameraData.channel));

              case 2:
                img = _context12.sent;
                _width = 640;
                _height = 480;

                if (img) {
                  _width = img.width;
                  _height = img.height;
                }

                drawingToolApp.setResolution(_width, _height);
                return _context12.abrupt("return");

              case 8:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));

      return function resolution() {
        return _ref12.apply(this, arguments);
      };
    }();

    resolution().then(function () {
      drawingToolApp.changeTarget({
        type: "display"
      }, objects);
    });
  };

  var onChangeConditionParameter = function onChangeConditionParameter(_ref13, value) {
    var cid = _ref13.cid,
        sid = _ref13.sid,
        pid = _ref13.pid,
        geoCondObj = _ref13.geoCondObj;

    if (!_selectedCondition.current) {
      return null;
    }

    _selectedCondition.current.setParameter({
      cid: cid,
      sid: sid,
      pid: pid,
      geoCondObj: geoCondObj
    }, value); // this.setState({})

  };

  var onChangeConditionsGeometry = function onChangeConditionsGeometry(_ref14, value) {
    var cid = _ref14.cid,
        sid = _ref14.sid,
        gid = _ref14.gid,
        gcid = _ref14.gcid,
        oindex = _ref14.oindex;

    if (!_selectedCondition.current) {
      return null;
    }

    _selectedCondition.current.setGeometry({
      cid: cid,
      sid: sid,
      gid: gid,
      gcid: gcid,
      oindex: oindex
    }, value); // this.setState({});

  };

  var saveVaProfile = function saveVaProfile(p) {
    var isReset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var _p = p;

    if (!p) {
      _p = profile; // const { editProfileName, eAStream } = this.state
      // _p.name = editProfileName
      // console.log('sj on set ', this.selectedCondition.map)
      // console.log('sj on set ', this.selectedCondition.toString())

      _p.conditionBase64 = encodeBase64(_selectedCondition.current.toString()); // if (_p.note) {
      //     _p.note.analyticalStream = eAStream
      // }
    }

    return setCameraVaProfileAPI(contextRoot, false, cameraData.nvr.ip, _p).then(function (result) {
      console.log(result.content);
    });
  }; // useEffect(() => {
  //     if(!_isMounted.current)
  //         return null
  //     if(_isReset.current) {
  //         drawingToolApp.setCallback({ onReady: () =>
  //             renderGeoObjs({
  //                 displayItem: conditionItems_displayItem,
  //                 displayItems: conditionItems_displayItems,
  //                 viewStatus
  //             })
  //         })
  //     }
  // }, [_isReset.current])


  useEffect(function () {
    if (!_isMounted.current) return null;
    if (!openAnalyticSetup) drawingToolApp.setCallback({
      onReady: function onReady() {
        return renderGeoObjs({
          displayItem: conditionItems_displayItem,
          displayItems: conditionItems_displayItems,
          viewStatus: viewStatus
        });
      }
    });
  }, [openAnalyticSetup]);
  useEffect(function () {
    if (!_isMounted.current) return null;

    var handleData = /*#__PURE__*/function () {
      var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return getCondition().then(function (cond) {
                  _selectedCondition.current = cond;
                  var cItems = cond.getConditionItems();
                  setConditionItems_items(cItems);
                  var selected = profile.id;
                  var name = profile.name;
                  var eAStream = profile.note && profile.note.analyticalStream;
                  var displayItem = null;
                  var displayItems = cItems.map(function (item, index) {
                    var cid = item.cid;
                    var sid = item.sid;
                    if (index == 0) displayItem = {
                      cid: cid,
                      sid: sid
                    };
                    return {
                      cid: cid,
                      sid: sid
                    };
                  });
                  setConditionItems_displayItem(displayItem);
                  setConditionItems_displayItems(displayItems);
                  drawingToolApp.setCallback({
                    onReady: function onReady() {
                      return renderGeoObjs({
                        displayItem: displayItem,
                        displayItems: displayItems,
                        viewStatus: viewStatus
                      });
                    }
                  });
                });

              case 2:
                return _context13.abrupt("return", _context13.sent);

              case 3:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }));

      return function handleData() {
        return _ref15.apply(this, arguments);
      };
    }();

    handleData();
  }, [JSON.stringify(profile)]);
  useEffect(function () {
    if (!_isMounted.current) {
      Progress.startSpin();
      var api_getCameraVaScheduleList = getCameraVaScheduleList(contextRoot, true, cameraData.nvr.ip, cameraData.channel);
      var api_getcameraVaProfileList = getCameraVaProfileList(contextRoot, true, cameraData.nvr.ip);
      $.when(api_getCameraVaScheduleList, api_getcameraVaProfileList).then(function (vaScheduleResult, vaProfileResult) {
        dispatch(setNvrIp(cameraData.nvr.ip)); // vaScheduleResult

        if (vaScheduleResult.value == true) setEnableVaSchedule(true);else setEnableVaSchedule(false); // vaProfileResult ----

        _initTemplate.current = _.filter(vaProfileResult.content, function (el) {
          return el.modification === false;
        })[0];
        var analyticData = {};

        _.forEach(vaProfileResult.content, function (el) {
          if (el.note && el.note.channel === cameraData.channel) analyticData = el;
        }); // create new template


        if (_.isEmpty(analyticData.id)) {
          handleCreateNewVaProfile(_initTemplate.current, true).then(function (resultProfile) {
            _isMounted.current = true;
            setProfile(resultProfile);
            Progress.done();
          }); // let newVaProfile = {
          //     conditionBase64: _initTemplate.current.conditionBase64,
          //     description: '',
          //     name: 'new_profile',
          //     note: {
          //         analyticalStream: 1,
          //         channel: cameraData.channel,
          //         templateId: _initTemplate.current.id,
          //     },
          //     tagColor: ''
          // }
          // createCameraVaProfileAPI(contextRoot, true, cameraData.nvr.ip, newVaProfile).then(createResult => {
          //     // _isNewProfile.current = true
          //     _isMounted.current = true
          //     setProfile(createResult.content[0])
          //     Progress.done()
          // })
        } else {
          _isMounted.current = true;
          setProfile(analyticData);
          Progress.done();
        }
      }); // getCameraVaProfileList(contextRoot, true, cameraData.nvr.ip).then(result => {
      //     _initTemplate.current = _.filter(result.content, el => el.modification === false)[0]
      //     let analyticData = {}
      //     _.forEach(result.content, el => {
      //         if(el.note && el.note.channel === cameraData.channel)
      //             analyticData = el
      //     })
      //     // create new template
      //     if(_.isEmpty(analyticData.id)) {
      //         let newVaProfile = {
      //             conditionBase64: _initTemplate.current.conditionBase64,
      //             description: '',
      //             name: 'new_profile',
      //             note: {
      //                 analyticalStream: 1,
      //                 channel: cameraData.channel,
      //                 templateId: _initTemplate.current.id,
      //             },
      //             tagColor: ''
      //         }
      //         createCameraVaProfileAPI(contextRoot, true, cameraData.nvr.ip, newVaProfile).then(createResult => {
      //             // _isNewProfile.current = true
      //             _isMounted.current = true
      //             setProfile(createResult.content[0])
      //             Progress.done()
      //         })
      //     } else {
      //         _isMounted.current = true
      //         setProfile(analyticData)
      //         Progress.done()
      //     }
      // })
    }

    return function () {
      setOpenAnalyticSetup(false);
      setEnableVaSchedule(false);
      setProfile({});
      setConditionItems_items([]);
      setConditionItems_displayItems(null);
      setConditionItems_displayItem(null);
      setViewStatus('multi');
      _isMounted.current = false;
      _initTemplate.current = null;
      _isNewProfile.current = false;
      _selectedCondition.current = 0;
      dispatch(setNvrIp(''));
    };
  }, []);
  if (!_isMounted.current || _.isEmpty(cameraData)) return null;
  var actions = {};

  _.set(actions, 'cancel', {
    text: gt('global.lbl-close'),
    handler: handleClose
  });

  _.set(actions, 'reset', {
    text: gt('global.lbl-answer-reset'),
    handler: handleReset
  });

  _.set(actions, 'confirm', {
    text: t(enableVaSchedule ? 'dlg-disable-schedule' : 'dlg-enable-schedule'),
    className: cx(enableVaSchedule ? 'button-error' : 'button-success'),
    // disabled: !formValid,
    handler: handleVaSchedule
  });

  var snapshotUrl = "".concat(contextRoot, "/camera/snapshot?nvrIp=").concat(cameraData.nvr.ip, "&channel=").concat(cameraData.channel);
  return /*#__PURE__*/React.createElement(ModalDialog, {
    id: id,
    title: t('dlg-camera-analytic-edit'),
    global: true,
    info: error,
    infoClassName: cx({
      'c-error': error
    }),
    actions: actions,
    closeAction: "cancel"
  }, /*#__PURE__*/React.createElement("div", {
    className: "analytic-setup"
  }, /*#__PURE__*/React.createElement("section", {
    className: "section-part"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title-2"
  }, t('analytic-setup.vaCondition'), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", {
    onClick: function onClick() {
      handleViewStatus("single");
    },
    className: cx({
      "focus": viewStatus === "single"
    })
  }, t('analytic-setup.viewSingle')), /*#__PURE__*/React.createElement("li", {
    onClick: function onClick() {
      handleViewStatus("multi");
    },
    className: cx({
      "focus": viewStatus === "multi"
    })
  }, t('analytic-setup.viewAll')))), /*#__PURE__*/React.createElement("div", {
    className: "analysis-content",
    key: cameraData.nvr.ip + cameraData.channel
  }, /*#__PURE__*/React.createElement("div", {
    className: "analysis-left custom-scroll"
  }, !_.isEmpty(conditionItems_items) && !_.isEmpty(conditionItems_displayItems) && !_.isEmpty(conditionItems_displayItem) && renderConditionItems()), /*#__PURE__*/React.createElement(DrawingToolReadBox, {
    isShow: !openAnalyticSetup,
    url: snapshotUrl,
    selected: profile.id
  })))), openAnalyticSetup && /*#__PURE__*/React.createElement(ConditionSetupPopup, {
    onClose: function onClose() {
      return setOpenAnalyticSetup(false);
    },
    channel: cameraData.channel,
    channelName: cameraData.name,
    imgUrl: snapshotUrl,
    selectedCondition: _selectedCondition.current,
    onChangeParameter: onChangeConditionParameter,
    onChangeGeometry: onChangeConditionsGeometry,
    onSave: function onSave() {
      return saveVaProfile();
    },
    supportPercentage: true
  }));
});
AnalyticCameraEdit.defaultProps = {
  id: 'g-analytic-camera-edit'
};
AnalyticCameraEdit.propTypes = {
  id: PropTypes.string
};
export default AnalyticCameraEdit;

var ConditionItems = /*#__PURE__*/function (_Component) {
  _inherits(ConditionItems, _Component);

  var _super = _createSuper(ConditionItems);

  function ConditionItems() {
    _classCallCheck(this, ConditionItems);

    return _super.apply(this, arguments);
  }

  _createClass(ConditionItems, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          items = _this$props.items,
          _onEdit = _this$props.onEdit,
          onToggle = _this$props.onToggle,
          viewStatus = _this$props.viewStatus;
      if (!items) return null;
      var cItems = {};

      try {
        items.map(function (it, index) {
          var onChangeEnable = it.onChangeEnable,
              name = it.name,
              enable = it.enable,
              noEnable = it.noEnable,
              sid = it.sid,
              cid = it.cid;

          var _name;

          if (sid) _name = t("subcondition_list." + name);else _name = t("condition." + name);
          if (!cItems[cid]) cItems[cid] = [];

          if (!sid) {
            cItems[cid] = [/*#__PURE__*/React.createElement(ConditionEnableItem, {
              cid: cid,
              sid: sid,
              displayItem: _this2.props.displayItem,
              displayItems: _this2.props.displayItems // onChangeDisplayItem={this.props.onChangeDisplayItem}
              ,
              onChangeDisplayItem: function onChangeDisplayItem() {},
              key: index,
              viewStatus: viewStatus,
              enable: enable,
              noEnable: noEnable // onToggle={(enable) => {
              //     onToggle(index, enable)
              //     return Promise.resolve()
              // }}
              ,
              onEdit: function onEdit() {
                _onEdit(cid, sid);
              },
              isSubcondition: sid,
              name: _name
            })].concat(_toConsumableArray(cItems[cid]));
          } else {
            cItems[cid] = [].concat(_toConsumableArray(cItems[cid]), [/*#__PURE__*/React.createElement(ConditionEnableItem, {
              cid: cid,
              sid: sid,
              displayItems: _this2.props.displayItems,
              displayItem: _this2.props.displayItem // onChangeDisplayItem={this.props.onChangeDisplayItem}
              ,
              onChangeDisplayItem: function onChangeDisplayItem() {},
              key: index,
              viewStatus: viewStatus,
              enable: enable,
              noEnable: noEnable // onToggle={(enable) => {
              //     onToggle(index, enable)
              //     return Promise.resolve()
              // }}
              ,
              onEdit: function onEdit() {
                _onEdit(cid, sid);
              },
              isSubcondition: sid,
              name: _name
            })]);
          }
        });
      } catch (error) {}

      return /*#__PURE__*/React.createElement("div", null, Object.keys(cItems).map(function (key) {
        return /*#__PURE__*/React.createElement("ul", null, cItems[key].map(function (i) {
          return i;
        }));
      }));
    }
  }]);

  return ConditionItems;
}(Component);

var ConditionEnableItem = /*#__PURE__*/function (_Component2) {
  _inherits(ConditionEnableItem, _Component2);

  var _super2 = _createSuper(ConditionEnableItem);

  function ConditionEnableItem() {
    var _this3;

    _classCallCheck(this, ConditionEnableItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this3 = _super2.call.apply(_super2, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this3), "handleToggle", function () {
      var _this3$props = _this3.props,
          onToggle = _this3$props.onToggle,
          enable = _this3$props.enable;
      onToggle(!enable).then(function () {
        _this3.setState({});
      });
    });

    return _this3;
  }

  _createClass(ConditionEnableItem, [{
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props2 = this.props,
          onEdit = _this$props2.onEdit,
          name = _this$props2.name,
          isEnable = _this$props2.enable,
          isSubcondition = _this$props2.isSubcondition,
          cid = _this$props2.cid,
          sid = _this$props2.sid,
          viewStatus = _this$props2.viewStatus,
          displayItems = _this$props2.displayItems,
          displayItem = _this$props2.displayItem;
      var isMultiDisplay = false;

      if (displayItems) {
        displayItems.map(function (item) {
          if (!sid && !item.sid) {
            if (cid == item.cid) {
              isMultiDisplay = true;
            }
          } else {
            if (cid == item.cid && sid == item.sid) {
              isMultiDisplay = true;
            }
          }
        });
      }

      var showItemIcon = /*#__PURE__*/React.createElement("i", {
        className: "far fa-eye-slash",
        onClick: function onClick(e) {
          _this4.props.onChangeDisplayItem(viewStatus, "add", {
            cid: cid,
            sid: sid
          });

          e.stopPropagation();
        }
      });

      if (isMultiDisplay) {
        showItemIcon = /*#__PURE__*/React.createElement("i", {
          className: "far fa-eye",
          onClick: function onClick(e) {
            _this4.props.onChangeDisplayItem(viewStatus, "remove", {
              cid: cid,
              sid: sid
            });

            e.stopPropagation();
          }
        });
      }

      var isSingleDisplay = false;

      if (displayItem && !displayItem.sid && !sid) {
        if (displayItem.cid == cid) isSingleDisplay = true;
      } else if (displayItem) {
        if (displayItem.cid == cid && displayItem.sid == sid) isSingleDisplay = true;
      }

      return /*#__PURE__*/React.createElement("li", {
        className: cx("profile-item", {
          "selected": viewStatus == "single" && isSingleDisplay
        }),
        onClick: function onClick(e) {
          //console.log("kz onclick id=", cid, sid)
          if (!isSingleDisplay) {
            _this4.props.onChangeDisplayItem(viewStatus, "add", {
              cid: cid,
              sid: sid
            });
          }

          e.stopPropagation();
        }
      }, this.props.viewStatus == "multi" ? showItemIcon : null, /*#__PURE__*/React.createElement("div", {
        className: "name"
      }, name), /*#__PURE__*/React.createElement("div", {
        className: "switch"
      }, this.props.noEnable ? null : /*#__PURE__*/React.createElement(LoadingBtn, {
        title: /*#__PURE__*/React.createElement("div", {
          onClick: function onClick() {
            if (!_this4.props.permissionDeny) _this4.handleToggle();
          },
          id: "subscribe1",
          className: "c-toggle-btn"
        }, /*#__PURE__*/React.createElement("input", {
          className: this.props.permissionDeny ? 'permissionDeny' : '',
          type: "checkbox",
          checked: isEnable
        }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
          for: "subscribe1",
          className: "on"
        }, gt('on')), /*#__PURE__*/React.createElement("label", {
          for: "subscribe1",
          className: "off"
        }, gt('off')), /*#__PURE__*/React.createElement("i", {
          className: "ic icon-ic_ridiobtn_fill "
        }))),
        element: "div",
        permissionDeny: this.props.permissionDeny,
        inputClassName: 'switchDiv'
      })), isSubcondition && false ? null : /*#__PURE__*/React.createElement("i", {
        onClick: onEdit,
        className: "fa fa-pencil-alt fa-list-alt"
      }));
    }
  }]);

  return ConditionEnableItem;
}(Component);

ConditionEnableItem.defaultPropt = {
  permissionDeny: ''
};
ConditionEnableItem.propTypes = {
  defaultEnable: PropTypes.bool,
  enable: PropTypes.bool,
  noEnable: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
  onEdit: PropTypes.func,
  name: PropTypes.string
};

function getDrawingObjs(objCount) {
  var geometry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var opacity = arguments.length > 2 ? arguments[2] : undefined;

  try {
    if (objCount == 0) return [];
    var geo = geometry;
    if (!opacity) opacity = GRAPHIC_OPACITY;

    var key = _.get(geo, '$.id');

    return [_objectSpread(_objectSpread({}, geo), {}, {
      id: key,
      opacity: opacity
    })];
  } catch (error) {
    console.error('getDrawingObjs fail', error);
    return [];
  }
}